export enum RoleAccess {
  None = 0,
  All = 1,
  //And Above
  ManagerAndAbove = 10,
  BackOfficeAndAbove = 11,
  //Only
  Payroll = 21,
  Admin = 22
}

export const RoleAccessMapping: Record<RoleAccess, string> = {
  [RoleAccess.None]: 'Disabled',
  [RoleAccess.All]: 'Everyone',
  [RoleAccess.ManagerAndAbove]: 'Manager and Above',
  [RoleAccess.BackOfficeAndAbove]: 'Back Office and Above',
  [RoleAccess.Payroll]: 'Payroll Only',
  [RoleAccess.Admin]: 'Admin Only'
};
